import React, { useState } from "react"
import { Modal, ModalBody, Row } from "reactstrap"
import { Stepper } from "react-form-stepper"
import SelectProduct from "./SelectProduct"
import InvoiceId from "./InvoiceId"
import Confirmation from "./Confirmation"

const ReadyToShipModal = ({ isModalOpen, setIsModalOpen }) => {
  const toggle = () => setIsModalOpen(!isModalOpen)
  const [activeStep, setActiveStep] = useState(0)

  const steps = [{ label: "Select Product" }, { label: "Invoice ID" }, { label: "Confirmation" }]

  const handleNextClick = () => {
    if (activeStep < 2) {
      setActiveStep(activeStep + 1)
    }
  }

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minHeight: "484px",
          minWidth: "50%",
          maxWidth: "80%",
        }}
      >
        <ModalBody>
          <h5 className="my-3">Ready to Ship</h5>

          <Stepper
            style={{ width: "100%" }}
            steps={steps}
            activeStep={activeStep}
            connectorStateColors={true}
            connectorStyleConfig={{
              completedColor: "#ffbd13",
              activeColor: "#ffbd13",
              disabledColor: "#eee",
            }}
            styleConfig={{
              activeBgColor: "#ffd813",
              completedBgColor: "#ffbd13",
              inactiveBgColor: "#eee",
              activeTextColor: "#111",
              completedTextColor: "#222",
              inactiveTextColor: "#444",
              circleFontSize: "0",
            }}
          />

          {activeStep === 0 && <SelectProduct />}
          {activeStep === 1 && <InvoiceId />}
          {activeStep === 2 && <Confirmation />}

          <div className="d-flex justify-content-end mt-3">
            <div className="d-flex gap-2 fw-medium">
              <div className="border border-dark rounded rounded-3 px-2 py-1 cursor-pointer" onClick={toggle}>Cancel</div>
              <div className="px-2 py-1 rounded rounded-3 text-white cursor-pointer" style={{ backgroundColor: "#48b9e2" }} onClick={handleNextClick}>
                {activeStep < 2 ? 'Next' : 'Got It'}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ReadyToShipModal
